import React from 'react';
import { useSelector } from 'react-redux';
import { AppState } from '../../store';

import styles from './NetWorth.module.css';

interface BurnRateProps {
  netWorth: number;
}

const BurnRate: React.FC<BurnRateProps> = ({ netWorth }) => {
  const { burnRate, exchangeRates } = useSelector((state: AppState) => ({
    burnRate: state.burnRate,
    exchangeRates: state.exchangeRates,
  }));

  if (!burnRate) {
    return null;
  }

  const exchangeRate = exchangeRates ? exchangeRates[burnRate.currency] : 0;
  const burnRateConverted = burnRate.amount * exchangeRate;
  const goingBroke = Math.floor(netWorth / burnRateConverted);

  const message = goingBroke > 0 ? `${goingBroke} months` : 'like, tomorrow';

  return (
    <h2>
      Going broke in: <span className={styles.emphasize}>{message}</span>
    </h2>
  );
};

export default BurnRate;
